import { Component, OnDestroy, OnInit } from '@angular/core'
import { environment } from 'src/environments/environment'
import { OrganizationsService } from '../../services/organizations.service'
import { Subscription } from 'rxjs'
import { ActivatedRoute } from '@angular/router'
import { OrganzationProfile } from 'src/app/modules/organization/models/organzation-profile.model'
import { TranslateService } from '@ngx-translate/core'
import { OrganizationStatus } from '../../models/organizations.enum'
import { SharedService } from 'src/app/shared/services/shared.service'

@Component({
	selector: 'app-organization-profile',
	templateUrl: './organization-profile.component.html',
	styleUrls: ['./organization-profile.component.scss'],
})
export class OrganizationProfileComponent implements OnInit, OnDestroy {
	subscription = new Subscription()
	organization: OrganzationProfile = new OrganzationProfile()
	attachmentPath: string = environment.attachmentPath
	status = OrganizationStatus
	constructor(
		private OrganizationsService: OrganizationsService,
		public translate: TranslateService,
		private route: ActivatedRoute,
		private sharedService: SharedService
	) {
	}

	ngOnInit(): void {
		let id = this.route.snapshot.paramMap.get('id') as string
		this.getOrganizationProfile(id)
	}

	getOrganizationProfile(id: string) {
		this.subscription.add(
			this.OrganizationsService.getOrganizationProfile(id).subscribe(
				(res: OrganzationProfile) => {
					this.organization = res
					this.OrganizationsService.activeOrganization.next(res.businessName)
					this.sharedService.headerTitle.next(`${res.businessName} - ${this.organization?.branches[0]?.name}`)
					localStorage.setItem('activeOrganization', `${res.businessName} - ${this.organization?.branches[0]?.name}`)

					this.sharedService.handleBreadCrumb('organization-profile', false, {
						name: '',
						id: this.organization?.id,
						url: '/layout/service-providers/organization-profile',
						queryParams: { ...res },
					})
				}))
	}


	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
